import { eventBus } from '../../core/events';
import type { StepRegistry } from '../StepRegistry';
import { wait } from './utils';

export function registerHudSteps(registry: StepRegistry): void {
  registry.register('hud-event', async (step) => {
    eventBus.emit('hud:event', step.params);
    await wait(step.duration || 500);
  });

  registry.register('hud-region', async (step) => {
    eventBus.emit('hud:region', step.params);
    await wait(step.duration || 500);
  });

  registry.register('hud-team', async (step) => {
    eventBus.emit('hud:team', step.params);
    await wait(step.duration || 500);
  });

  registry.register('hud-weather', async (step) => {
    eventBus.emit('hud:weather', step.params);
    await wait(step.duration || 500);
  });
}
